module.exports = __webpack_public_path__ + "img/233.f5b3fe4a.jpg";